import type React from "react";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, type ToastContainerProps, toast } from "react-toastify";

export const ToastNotification: React.FC<ToastContainerProps> = (props) => (
  <div data-cy="toast-notification-container">
    <ToastContainer
      closeOnClick
      draggable
      hideProgressBar
      newestOnTop
      autoClose={5000}
      pauseOnHover={false}
      position={toast.POSITION.TOP_CENTER}
      {...props}
    />
  </div>
);
